import { PRE_GET_PARTNERS_API, PRE_POST_STEP_STATUS } from './types';

// Récupère la liste des partenaires (GET /partners/all)
// prefix optionnel : restreint l'appel (et la mise à jour du store) à ce partenaire.
export const getPartnersApi = (prefix = null) => ({
	type: PRE_GET_PARTNERS_API,
	prefix,
});

// Déclenche l'étape suivante de configuration (POST partnersConfig/step-status)
// body = { prefix, data } ; la réponse contient le partenaire mis à jour.
export const postStepStatus = ({ prefix, data = {} }) => ({
	type: PRE_POST_STEP_STATUS,
	body: { prefix, data },
});
